import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { ConfigurationService } from './configuration.service';
import { AuthenticationService } from './authentication.service';
import { BarnBooking, CreateBarnBlackoutRequest, CreateBarnBlackoutResult, CreateBarnBookingRequest } from '../models/barn';

@Injectable({
  providedIn: 'root'
})
export class BarnService {

  constructor(private http:HttpClient, private configService:ConfigurationService, private authenticationService:AuthenticationService) {
    this.baseUrl = this.configService.getApiEndpoint();
  }

  baseUrl:string;

  getCurrentPlayerId():number {
    const player = this.authenticationService.loginResult?.player;
    return player ? player.playerId : 0;
  }

  async getAvailability(startAt:Date, endAt:Date):Promise<Array<BarnBooking>> {
    let endpoint = `${this.baseUrl}/barnavailability`;
    let request = {
      startAt: startAt.toISOString(),
      endAt: endAt.toISOString(),
      playerId: this.getCurrentPlayerId()
    };

    return await firstValueFrom(this.http.post<Array<BarnBooking>>(endpoint, request));
  }

  async createBooking(request:CreateBarnBookingRequest):Promise<{ bookingId:number }> {
    let endpoint = `${this.baseUrl}/barnbooking`;
    return await firstValueFrom(this.http.post<{ bookingId:number }>(endpoint, request));
  }

  async cancelBooking(bookingId:number):Promise<void> {
    let endpoint = `${this.baseUrl}/barnbooking`;
    await firstValueFrom(this.http.request<void>('DELETE', endpoint, {
      body: { bookingId: bookingId, playerId: this.getCurrentPlayerId() }
    }));
  }

  async createBlackout(request:CreateBarnBlackoutRequest):Promise<CreateBarnBlackoutResult> {
    let endpoint = `${this.baseUrl}/barnblackout`;
    return await firstValueFrom(this.http.post<CreateBarnBlackoutResult>(endpoint, request));
  }

  async cancelBlackout(bookingId:number, ruleId:number|null, deleteSeries:boolean):Promise<void> {
    let endpoint = `${this.baseUrl}/barnblackout`;
    await firstValueFrom(this.http.request<void>('DELETE', endpoint, {
      body: {
        bookingId: bookingId,
        ruleId: ruleId,
        deleteSeries: deleteSeries,
        playerId: this.getCurrentPlayerId()
      }
    }));
  }

  async getNotificationRecipients():Promise<Array<number>> {
    let endpoint = `${this.baseUrl}/barnnotifications`;
    const result = await firstValueFrom(this.http.post<{ playerIds:Array<number> }>(endpoint, {
      playerId: this.getCurrentPlayerId()
    }));
    return result.playerIds ?? [];
  }

  async saveNotificationRecipients(playerIds:Array<number>):Promise<Array<number>> {
    let endpoint = `${this.baseUrl}/barnnotifications`;
    const result = await firstValueFrom(this.http.put<{ playerIds:Array<number> }>(endpoint, {
      playerId: this.getCurrentPlayerId(),
      playerIds: playerIds
    }));
    return result.playerIds ?? [];
  }
}
